const cropImage = (imageSrc, pixelCrop, { maxDim = 1200, quality = 0.82, transparent = false } = {}) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => {
      const scale = Math.min(1, maxDim / Math.max(pixelCrop.width, pixelCrop.height));
      const outW = Math.round(pixelCrop.width * scale);
      const outH = Math.round(pixelCrop.height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = outW;
      canvas.height = outH;
      const ctx = canvas.getContext('2d');
      if (!transparent) {
        // JPEG doesn't support transparency — fill white to avoid black background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, outW, outH);
      }
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        outW,
        outH,
      );
      const mime = transparent ? 'image/png' : 'image/jpeg';
      canvas.toBlob((blob) => {
        if (!blob) { reject(new Error('Canvas toBlob failed')); return; }
        resolve(blob);
      }, mime, transparent ? undefined : quality);
    });
    image.addEventListener('error', reject);
    image.src = imageSrc;
  });

export default cropImage;
